export const blockIconsPhotoandimageTimelapseNew = (
	<span className='material-symbols-outlined'>timelapse</span>
);
